import * as React from 'react';
import config from '../../config/config';
import shareConfig from '../../config/share.config';
import server from '../../server/apiServer';
import { Link } from 'react-router-dom';
import HeaderComp from '../../components/common/header';
import FooterComp from '../../components/common/footer';
import ToTopComp from '../../components/common/toTop';
import ItemComp from '../../components/main/item';

interface IProps extends React.Props<any> {
    match: any
}

class NewsComp extends React.Component<IProps, any> {
    public state = {
        id: this.props.match.params.id || '',
        data: {
            articleName: '',
            releaseTime: '',
            source: '',
            articleAuthor: '',
            articleSummary: '',
            articleContent: '',
            labelModelList: []
        },
        list: []
    };
    public componentDidMount() {
        (window as any)._hmt.push(['_trackPageview', `/news/${this.state.id}`]);
        window.scrollTo(0, 0);
        this.getData();
        this.getHotArticle();
    }
    public componentWillReceiveProps(props: IProps) {
        window.scrollTo(0, 0);
        if(this.state.id === props.match.params.id) {
            return;
        }
        this.setState({
            id: props.match.params.id || '',
            data: {
                articleName: '',
                releaseTime: '',
                source: '',
                articleAuthor: '',
                articleSummary: '',
                articleContent: '',
                labelModelList: []
            },
            list: []
        }, () => {
            this.getData();
            this.getHotArticle();
        });
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <HeaderComp parentProps={this.props}/>
                <div className="inner-container">
                    <h5 className="news-title">{state.data.articleName}</h5>
                    <p className="news-time">{state.data.releaseTime}</p>
                    {
                        (state.data.source || state.data.articleAuthor) ? <div className="news-user">
                        {state.data.source ? <span>来源：{state.data.source}</span> : null}
                        {(state.data.source && state.data.articleAuthor) ? '|' : null} 
                        {state.data.articleAuthor ? <em>作者：{state.data.articleAuthor}</em> : null}
                    </div> : null
                    }
                    <h4 className="news-dtitle">{state.data.articleSummary}</h4>
                    <div className="news-detail" dangerouslySetInnerHTML={{__html: state.data.articleContent}} />
                    <div className="news-label">
                        {
                            state.data.labelModelList.map((v: any, k:number) => {
                                return (
                                    <Link to={`/listPage/${v.labelNum}?name=${encodeURIComponent(v.lbelName)}`} key={`detaliLabel${k}`}>{v.lbelName}</Link>
                                )
                            })
                        }
                        
                    </div>
                    <div className="news-share">
                        <img src={require('../../assets/images/icon-share.png')} /> <em>分享：</em> <span onClick={() => this.shareSinaWB()}><img src={require('../../assets/images/icon-weibo.png')} /> <em>微博</em></span>
                    </div>
                    <p className="news-hot-title">热门文章</p>
                    <ul className="main-list">
                        {
                            state.list.map((v: any, k: number) => {
                                return (
                                    <ItemComp key={`main-item${k}`} data={v} divider={true}/>
                                );
                            })
                        }
                    </ul>
                </div>
                <FooterComp />
                <ToTopComp />
            </div>
        );
    }
    /**
     * 
     * @param titleStr 分享标题
     * @param descStr 分享描述
     */
    private setShareInfo(titleStr: string, descStr: string) {
        const xhrData = `jsApiDomain=&url=${encodeURIComponent(window.location.href.split('#')[0])}`;
        (window as any).WeChatShare({
            callback() {
                const shareInfo = shareConfig.detail;
                const [title, desc, imgUrl, link] = [
                    titleStr,
                    descStr,
                    shareInfo.imgUrl,
                    shareInfo.link()
                ];
                (window as any).wx.onMenuShareAppMessage({
                    desc,
                    imgUrl,
                    link,
                    title
                });
                (window as any).wx.onMenuShareTimeline({
                  desc,
                  imgUrl,
                  link,
                  title
                });
            },
            data: xhrData,
            url: config.WAPAPI
        });
    }
    // 获取页面数据
    private async getData() {
        const r = await server.get('wap/detail', {
            id: this.state.id
        });
        if(r.code === 1) {
            this.setState({
                data: r.obj
            });
            this.setShareInfo(r.obj.articleName + '-慧乐居', r.obj.articleSummary);
        }
    }
    // 新浪微博分享
    private shareSinaWB() {
        window.location.href = `http://service.weibo.com/share/share.php?appkey=&title=${this.state.data.articleName}&url=${encodeURIComponent(window.location.href)}&pic=${encodeURIComponent(shareConfig.main.imgUrl)}&searchPic=false&style=simple`;
    }
    // 热门文章
    private async getHotArticle() {
        const r = await server.get('wap/hotArticle', {
            id: this.state.id
        });
        if(r.code === 1) {
            this.setState({
                list: r.obj
            });
        }
    }
}

export default NewsComp;


// WEBPACK FOOTER //
// ./src/containers/news/index.tsx